export default __webpack_public_path__ + "static/natalia-f4eb6e9b308ae5f0211c33c977e58ce0.png";